import React from 'react';
import './MultipleAccounts.less';
import { getBrandImageUrl, getFlagImageUrl, MAX_COL_SIZE } from '../../utils/constants';
import { processTranslation, chunkArray } from '../utils/commonUtil';
import { TranslateUtils } from 'epc-i18n-utils';

import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import AlertBox from "../Alert/Alert";
import ConfirmBrandButtonHolder from '../ButtonHolder/ConfirmBrandButtonHolder';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import InfoCard from '../Card/InfoCard';


export default class MultipleAccounts extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    renderLanguageCurrencyMismatchContent() {
        const { translations, emailAddress, numberOfAccounts, handleFormSubmit } = this.props;
        return (
            <div className="language-currency-mismatch-content">

                <div className="main-col">
                    <div className="panel-head">
                        <h1 className="header">{translations['ipmob.multiple_accounts.lcm.heading']}</h1>
                    </div>

                    <div className="multiple-accounts-desc">
                        <p
                            className="multiple-accounts-pg-desc-text"
                            /* eslint-disable-next-line react/no-danger */
                            dangerouslySetInnerHTML={{
                                __html: TranslateUtils.getText('ipmob.multiple_accounts.lcm.desc', { numberOfAccounts, emailAddress }, translations)
                            }}
                        />
                        <p className="multiple-accounts-pg-desc-text">{translations['ipmob.multiple_accounts.lcm.desc_2']}</p>
                        <p className="multiple-accounts-pg-desc-text">{translations['ipmob.multiple_accounts.lcm.desc_3']}</p>
                    </div>

                    <ContinueButtonHolder
                        enableContinueButton
                        handleContinueButtonClick={handleFormSubmit}
                        translations={translations}
                        enableBackButton={false}
                        continueButtonId={'multipleAccountsContinueBtn'}
                    />
                </div>

                <div className="spacer-col" />

                <div className="info-card-col">
                    <InfoCard className="multiple-accounts-info-card">
                        <div className="info-card-header">{translations['ipmob.multiple_accounts.lcm.info.heading']}</div>
                        {/* eslint-disable-next-line react/no-danger */}
                        <div className="info-card-text" dangerouslySetInnerHTML={{ __html: translations['ipmob.multiple_accounts.lcm.info.desc'] }} />
                    </InfoCard>
                </div>
            </div>
        );
    }

    renderConfirmBrandColumn(chunk, colIndex) {
        const { handleBrandSelection, translations } = this.props;
        return (
            <td key={colIndex}>
                {chunk.map((primarySite, index) => {
                    const brandImage = getBrandImageUrl(primarySite.name);
                    const flagImage = getFlagImageUrl(primarySite.name);
                    return (
                        <div key={index}>
                            <ConfirmBrandButtonHolder
                                enableContinueButton
                                handleConfirmBrandButtonClick={(event) => handleBrandSelection(event, primarySite)}
                                translations={translations}
                                continueButtonId={`confirmBrandContinueBtn${colIndex * MAX_COL_SIZE + index}`}
                                data={primarySite}
                                brandImage={brandImage}
                                flagImage={flagImage}
                            />
                        </div>
                    );
                })}
            </td>
        );
    }

    getConfirmBrandButtons() {
        const { integratedBrandsPrimarySiteList } = this.props;

        // Group sites by brand
        const sortedPrimarySiteList = integratedBrandsPrimarySiteList.sort((a, b) =>
            a.humanReadableName.localeCompare(b.humanReadableName)
        );

        // Max 5 buttons per column
        const chunks = chunkArray(sortedPrimarySiteList, MAX_COL_SIZE);

        return (
            <div className="multiple-accounts-pg-content">
                <table>
                    <tbody>
                        <tr>
                            {chunks.map((chunk, colIndex) => this.renderConfirmBrandColumn(chunk, colIndex))}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const {
            translations,
            handleLanguageCurrencyMismatch,
            emailAddress,
            serviceError,
            handleAlertDismiss,
        } = this.props;

        return (<div className="multiple-accounts-pg">
            <div className="multiple-accounts-pg-wrapper container">
                {
                    (serviceError)
                        ? <div className="alert-panel">
                            <AlertBox
                                messageKey={serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                size={'sm'}
                            />
                        </div>
                        : null
                }
                <img className="multiple-accounts-pg-bg-img" src={backgroundImage()} />
                <div className="page-content">
                    {handleLanguageCurrencyMismatch?
                        this.renderLanguageCurrencyMismatchContent()
                        : <div>
                            <div className="panel-head">
                                <h1 className="header">{translations['ipmob.multiple_accounts.heading']}</h1>
                            </div>
                            <div className="multiple-accounts-pg-description-1">
                                {/* eslint-disable-next-line react/no-danger */}
                                <p dangerouslySetInnerHTML={{ __html: processTranslation(translations['ipmob.multiple_accounts.description_1'], [emailAddress]) }} />
                            </div>
                            <div className="multiple-accounts-pg-description-2">
                                {/* eslint-disable-next-line react/no-danger */}
                                <p dangerouslySetInnerHTML={{ __html: translations['ipmob.multiple_accounts.description_2'] }} />
                            </div>
                            {this.getConfirmBrandButtons()}
                        </div>}

                </div>
            </div>
        </div>);
    }
}
